import { Injectable, EventEmitter, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BookingParametersInterface } from '../../entities/bookingParameters';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { Shop } from '../../entities/shop';

@Injectable({
  providedIn: 'root'
})
export class ShopSearchHelperService {
  // broadcasts new bookingParameters info
  readonly newBookingParameters = new EventEmitter<BookingParametersInterface>(true);
  readonly onFormMinifyChange = new EventEmitter<boolean>();
  private readonly storageName = 'trackedDateSelection';
  _formMinified = false; // tells you if the form should be currently minimized or not.
  customerHasSetDate = false; // if the datepicker should pop up automatically or not
  customerHasSetDateTracked = this.localStorage.get(this.storageName, false); // if the datepicker should pop up automatically
  loading = false; // used to show rödler in search button
  loadingOutOfTown = false; // used to show rödler on shops that are out of town
  loadingInTown = false; // used to show rödler on shops that are in town
  guidanceMode = true; // used to activate or deactivate focusing next formgroup
  isBrowser: boolean;
  lastSelectedShop: Shop;

  set formMinified(val) {
    this._formMinified = val;
    setTimeout(() => {
      this.onFormMinifyChange.emit(val);
    });
  }

  get formMinified() {
    return this._formMinified;
  }

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private localStorage: LocalStorageService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  updateBookingParameters(data: BookingParametersInterface) {
    this.newBookingParameters.emit(data);
  }

  setCustomerHasSetDateTracked() {
    this.customerHasSetDateTracked = true;
    this.localStorage.set(this.storageName, true);
  }

  /**
   * checks the user agent if a browser is chrome/firefox. Will return false on SSR
   */
  isChrome() {
    if (this.isBrowser) {
      if (navigator.userAgent.toLowerCase().indexOf('chrome') !== -1) {
        return true;
      }
      if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
        return true;
      }
    }
    return false;
  }
}
